import Role from "enums/Role";
import { useIsMyScope } from "context/MyScopeContext";
import { useCheckUserRole } from "hooks/useCheckUserRole";

/**
 * Manager-and-above columns and tools. Off on /my for every role: they exist to
 * tell one person's records from another's, and there every record is the viewer's.
 */
export const useAdminTools = (): boolean => {
  const isManagerOrHigher = useCheckUserRole(Role.Manager);
  const isMyScope = useIsMyScope();
  return isManagerOrHigher && !isMyScope;
};
